import { useState } from "react";
import { POST } from "./api";
import { C, Card, Field, Btn } from "./theme";
import { useLang } from "./i18n";

export default function LoginPage({ onLogin }) {
  const { t } = useLang();
  const [id, setId] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!id || !pw) return;
    setLoading(true); setErr("");
    try {
      const data = await POST("/api/auth/login", { id, password: pw });
      localStorage.setItem("gpu_fabric_token", data.token);
      localStorage.setItem("gpu_fabric_user", JSON.stringify(data.user));
      onLogin(data.user);
    } catch (e) { setErr(e.message); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:"100vh", background:C.bg, display:"flex",
      alignItems:"center", justifyContent:"center" }}>
      <div style={{ width:360 }}>
        <div style={{ textAlign:"center", marginBottom:30 }}>
          <div style={{ fontFamily:"'Rajdhani',sans-serif", fontWeight:700,
            fontSize:28, color:C.text, letterSpacing:3 }}>NEOALI GPUS</div>
          <div style={{ fontFamily:"monospace", fontSize:10, color:C.dim2,
            letterSpacing:3, marginTop:3 }}>RESOURCE MANAGER · SECURE LOGIN</div>
        </div>
        <Card style={{ padding:26 }}>
          <form onSubmit={e => { e.preventDefault(); submit(); }}>
            <Field label={t("user_id")} value={id} onChange={setId} placeholder="ID"/>
            <Field label={t("password")} value={pw} onChange={setPw} type="password" placeholder={t("password")}/>
            {err && <div style={{ color:C.red, fontSize:11, marginBottom:10 }}>{err}</div>}
            <Btn full variant="green" onClick={submit} disabled={loading}>
              {loading ? "..." : "→ LOGIN"}
            </Btn>
          </form>
        </Card>
      </div>
    </div>
  );
}
